export default __webpack_public_path__ + "static/media/telegram.00660bb8.svg";